// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] || chunkId) + "." + {"102":"59090d67","133":"3a12570c","182":"ccb73af9","255":"afdc9209"}[chunkId] + ".chunk.js";
};